/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgEditFilled = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1754 0q61 0 114 21t94 60 63 91 23 114q0 47-10 84t-28 69-44 62-58 61l-424-423q31-31 59-57t60-44 67-28 84-10zm-420 290 422 422L753 1713 0 2046l348-759 986-997z"
    }));
export default SvgEditFilled;
